import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import {ContextualMenuThumbnailItem} from '@Components/contextual-menu/components/contextual-menu-thumbnail-item';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {ThumbnailItemSelectionState} from '@Components/thumbnail-item';
import {LayoutBackgroundOptionTypes} from '@Panels/poster-editor-item-background-panel/components/layout-background-panel';
import {updateOptionsPanelHeight} from '@Components/poster-editor/library/poster-editor-library';
import styles from './layout-background-type-option.module.scss';

interface LayoutBackgroundTypeOptionProps {
  panelId: string;
  type: LayoutBackgroundOptionTypes;
  updateBackgroundFillType(fillType: LayoutBackgroundOptionTypes): void;
}

export function LayoutBackgroundTypeOption({...props}: LayoutBackgroundTypeOptionProps): ReactElement | null {
  useEffect((): void => {
    setTimeout((): void => {
      updateOptionsPanelHeight(props.panelId, props.type === LayoutBackgroundOptionTypes.COLOR ? '282px' : '158px');
    }, 200);
  }, [props.type]);

  return (
    <ul className="flex-h-row spacing-m-0">
      <ContextualMenuThumbnailItem
        thumbnail={<Icon icon="icon-ban" size={IconSize.SIZE_ICON_32} />}
        isSelected={props.type === LayoutBackgroundOptionTypes.NONE}
        selectionState={ThumbnailItemSelectionState.OUTLINE}
        text={window.i18next.t('pmwjs_none')}
        onClick={(): void => {
          props.updateBackgroundFillType(LayoutBackgroundOptionTypes.NONE);
        }}
      />
      <ContextualMenuThumbnailItem
        thumbnail={<div className={`${styles.solid} radius-8`} />}
        isSelected={props.type === LayoutBackgroundOptionTypes.COLOR}
        selectionState={ThumbnailItemSelectionState.OUTLINE}
        text={window.i18next.t('pmwjs_color')}
        onClick={(): void => {
          props.updateBackgroundFillType(LayoutBackgroundOptionTypes.COLOR);
        }}
      />
    </ul>
  );
}
